import { ServiceException } from '../service-exception';

export class PairingException extends ServiceException {
  refresh: boolean;

  constructor(message: string, refresh: boolean) {
    super(message);

    this.refresh = refresh;
  }
}
